module.exports = __webpack_public_path__ + "img/vendor-logo-mark.091193da.png";